/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRegimenChecklistItem } from 'app/shared/model/regimen-checklist-item.model';
import { ITreatmentCycle } from 'app/shared/model/treatment-cycle.model';

export interface ITreatmentCycleCheckListItem {
  id?: string;
  result?: boolean | null;
  resultComment?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  checklistItem?: IRegimenChecklistItem | null;
  cycle?: ITreatmentCycle | null;
}

export const defaultValue: Readonly<ITreatmentCycleCheckListItem> = {
  result: false,
  active: false,
};
